module.exports = __webpack_public_path__ + "img/expire.592800b2.png";